<div class="modal-content text-center">
  <button aria-label="Close" class="close" (click)="activeModal.dismiss()" type="button">
    <span class="fas fa-times"></span>
  </button>
  <div class="onboarding-content">
    <h4 class="onboarding-title">
      <ng-template [ngIf]="!editPaymentTemplateData">
        {{ 'ResSettings.ResAddPaymentTemplate.CreateNewDownPayment' | translate }}</ng-template
      >
      <ng-template [ngIf]="editPaymentTemplateData">{{
        'ResSettings.ResAddPaymentTemplate.ChangeDepositeTemplate' | translate
      }}</ng-template>
    </h4>
    <form [formGroup]="paymentTemplateFormGroup">
      <div fxLayout="row" fxLayoutGap="15px">
        <div fxFlex>
          <div class="form-group">
            <label for="">
              {{ 'ResSettings.ResAddPaymentTemplate.Name' | translate }}<br />
              <small>{{ 'ResSettings.ResAddPaymentTemplate.ForInternalUseOnly' | translate }}</small>
            </label>
            <input
              class="form-control"
              placeholder="Geben Sie einen Namen ein..."
              name="name"
              formControlName="name"
              type="text"
              value=""
              ngbAutofocus
            />
          </div>
        </div>
        <div fxFlex>
          <div class="form-group">
            <label for=""
              >{{ 'ResSettings.ResAddPaymentTemplate.MinNumberOfPeople' | translate }}<br />
              <small>{{ 'ResSettings.ResAddPaymentTemplate.FromHowManyPeople' | translate }}</small></label
            >
            <number-spinner
              name="minGuests"
              [min]="1"
              [max]="1000"
              [step]="1"
              [precision]="1"
              [inputDisabled]="false"
              [defaultValue]="+paymentTemplateFormGroup.value.minGuests"
              (whenChange)="minGuestsChanged($event)"
            ></number-spinner>
          </div>
        </div>
      </div>
      <div>
        <div class="form-group">
          <label for="">{{ 'ResSettings.ResAddPaymentTemplate.TypeOfPayment' | translate }}</label>
          <br />
          <mat-radio-group
            aria-label="Wähle eine Option"
            formControlName="paymentType"
            (change)="paymentInfoTemplate($event.value)"
          >
            <mat-radio-button [value]="0">{{
              'ResSettings.ResAddPaymentTemplate.Complete' | translate
            }}</mat-radio-button>
            <mat-radio-button [value]="1" style="margin-left: 20px;">{{
              'ResSettings.ResAddPaymentTemplate.CreditCardGuarantee' | translate
            }}</mat-radio-button>
          </mat-radio-group>
        </div>
        <p *ngIf="paymentTemplateFormGroup.value.paymentType == 0">
          <i class="fas fa-info-circle"></i>&nbsp;{{ 'ResSettings.ResAddPaymentTemplate.fullPaymentText' | translate }}
        </p>
        <p *ngIf="paymentTemplateFormGroup.value.paymentType == 1">
          <i class="fas fa-info-circle"></i>&nbsp;{{ 'ResSettings.ResAddPaymentTemplate.ccPaymentText' | translate }}
        </p>

        <div class="row" *ngIf="paymentTemplateFormGroup.value.paymentType == 1">
          <div class="col-sm-12">
            <div class="form-group" formArrayName="paymentCharged">
              <div style="display: flex; margin-bottom: 5px">
                <div style="flex: 1;">
                  <label for="">{{ 'RecurrenceTab.common.duration' | translate }}</label>
                </div>
                <div style="flex: 1;">
                  <label for="">{{ 'ResSettings.ResAddPaymentTemplate.TypeOfCancellation' | translate }}</label>
                </div>
                <div style="flex: 1;">
                  <label for="">{{ 'ResSettings.ResAddPaymentTemplate.ChargedValue' | translate }} (%)</label>
                </div>
              </div>
              <ng-container>
                <div
                  style="display: flex; margin-bottom: 5px"
                  *ngFor="let group of formData.controls; let i = index"
                  [formGroupName]="i"
                >
                  <!-- Cancellation Type -->
                  <div style="flex: 1; margin-right: 1%;">
                    <input
                      type="number"
                      matInput
                      [min]="1"
                      [step]="1"
                      formControlName="durationValue"
                      class="form-control"
                      (change)="paymentInfoTemplate($event.value)"
                    />
                  </div>

                  <!-- Duration Dropdown -->
                  <div style="flex: 1; margin-right: 1%;">
                    <select
                      class="form-control"
                      formControlName="cancellationType"
                      (change)="paymentInfoTemplate($event.value)"
                    >
                      <option [value]="0">
                        {{ 'ResSettings.ResAddPaymentTemplate.Day' | translate }}
                      </option>
                      <option [value]="1">
                        {{ 'ResSettings.ResAddPaymentTemplate.Hour' | translate }}
                      </option>
                    </select>
                    <!-- <select
                      class="form-control"
                      formControlName="durationValue"
                      style="max-width: 220px"
                      (change)="paymentInfoTemplate($event.value)"
                    >
                      <option
                        *ngFor="let duration of group.get('cancellationType').value == 0 ? daysList : hoursList"
                        [value]="duration"
                      >
                        {{ duration }} {{ getLabel(group.get('cancellationType').value, duration) | translate }}
                      </option>
                    </select> -->
                  </div>

                  <!-- Charged Value -->
                  <div style="flex: 1; margin-right: 1%;">
                    <input
                      type="number"
                      matInput
                      [min]="0"
                      [max]="100"
                      [step]="1"
                      formControlName="chargedValue"
                      class="form-control"
                      (change)="paymentInfoTemplate($event.value)"
                    />
                  </div>

                  <div>
                    <button class="btn btn-white" type="button" (click)="removeDay(i)">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </div>
              </ng-container>
              <button
                class="btn btn-dark btn-circle"
                type="button"
                style="margin-top: 5px"
                (click)="addNewDay(); paymentInfoTemplate($event.value)"
              >
                {{ 'ResSettings.ResAddPaymentTemplate.AddNewDay' | translate }}
              </button>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="">{{ 'ResSettings.ResAddPaymentTemplate.FlatRateForEveryOne' | translate }}</label>
          <br />
          <mat-radio-group
            aria-label="Wähle eine Option"
            formControlName="priceOption"
            (change)="paymentInfoTemplate($event.value)"
          >
            <mat-radio-button value="guest">{{
              'ResSettings.ResAddPaymentTemplate.PerGuest' | translate
            }}</mat-radio-button>
            <mat-radio-button value="flatrate" style="margin-left: 20px;">{{
              'ResSettings.ResAddPaymentTemplate.LumSum' | translate
            }}</mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="form-group">
          <label *ngIf="paymentTemplateFormGroup.value.priceOption === 'guest'">
            {{
              'ResSettings.ResAddPaymentTemplate.' +
                (paymentTemplateFormGroup.value.paymentType == 0
                  ? 'AmountToBePaidForEachGuest'
                  : 'AmountToBePaidForEachGuestCC') | translate
            }}
          </label>
          <label for="" *ngIf="paymentTemplateFormGroup.value.priceOption === 'flatrate'">{{
            'ResSettings.ResAddPaymentTemplate.AmountToBePaidForLumSum' | translate
          }}</label>
          <div class="input-group">
            <input
              class="form-control"
              placeholder="Betrag eingeben..."
              value="0"
              formControlName="price"
              style="max-width:165px"
              mask="0*.00"
              [dropSpecialCharacters]="false"
            />
            <div class="input-group-append">
              <div class="input-group-text">{{ 'ResSettings.ResAddPaymentTemplate.Eur' | translate }}</div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label *ngIf="paymentTemplateFormGroup.value.paymentType == 0">{{
            'ResSettings.ResAddPaymentTemplate.WaitTimeForReservationUntilCancel' | translate
          }}</label>
          <label *ngIf="paymentTemplateFormGroup.value.paymentType == 1">{{
            'ResSettings.ResAddPaymentTemplate.WaitTimeForReservationUntilCancelCC' | translate
          }}</label>
          <select class="form-control" formControlName="cancelTime" style="max-width: 220px">
            <option *ngFor="let time of paymentCancelTimes" [value]="time">
              {{ time }}
              <ng-template [ngIf]="time === 1">{{ 'ResSettings.ResAddPaymentTemplate.Hour' | translate }}</ng-template>
              <ng-template [ngIf]="time > 1">{{ 'ResSettings.ResAddPaymentTemplate.Hours' | translate }}</ng-template>
            </option>
          </select>
        </div>

        <div class="form-group">
          <label>{{ 'ResSettings.ResAddPaymentTemplate.InfoTextForReservation' | translate }}</label>
          <textarea class="form-control" formControlName="infoText" rows="5"></textarea>
          <div class="textarea-append">
            <span
              >{{ 'ResSettings.ResAddPaymentTemplate.MagicVariables' | translate }}
              <i class="fa fa-info-circle" matTooltip="Magische Variablen werden durch deren Werte ersetzt"></i
            ></span>
            <div class="variables">
              <button class="badge badge-default" (click)="addVariable('[betrag]')">
                [{{ 'ResSettings.ResAddPaymentTemplate.Amount' | translate }}]
              </button>
              <button class="badge badge-default" (click)="addVariable('[betragproPerson]')">
                [{{ 'ResSettings.ResAddPaymentTemplate.AmountPerPerson' | translate }}]
              </button>
            </div>
          </div>
        </div>

        <div class="alert alert-danger borderless" *ngIf="error" style="width: 100%">{{ error }}</div>

        <button
          class="btn btn-primary btn-block btn-lg"
          (click)="add()"
          *ngIf="!editPaymentTemplateData"
          [promiseBtn]="addObservable"
        >
          {{ 'ResSettings.ResAddPaymentTemplate.CreateDepositTemplate' | translate }}
        </button>
        <button
          class="btn btn-primary btn-block btn-lg"
          (click)="save()"
          *ngIf="editPaymentTemplateData"
          [promiseBtn]="editObservable"
        >
          {{ 'ResSettings.ResAddPaymentTemplate.SaveDepositTemplate' | translate }}
        </button>
        <button
          class="btn btn-link btn-sm delete-button"
          (click)="delete()"
          *ngIf="editPaymentTemplateData"
          [promiseBtn]="deleteObservable"
        >
          {{ 'ResSettings.ResAddPaymentTemplate.DeleteDepositTemplate' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
